// import 'core-js/features/object/from-entries';
// import 'core-js/features/array/flat';

import './styles.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import Editor from "./editor"
import { ToolbarContext } from './plugins/ToolbarContext';

type Options = {
  editorContainerElement: HTMLElement,
  onAutoSave?: (content: string) => void,
  onUpdate?: (content: string) => void,
  editorType: 'none' | 'basic',
  showEquationEditorButton?: boolean,
  initialData?: string,
  equationEditorContainerElement?: HTMLElement
}

export default class EssayEditor {
  options: Options;
  constructor(options: Options) {
    this.options = options;
    const millisecondsSinceEpoch = Date.now();

    ReactDOM.createRoot(options.editorContainerElement).render(
      <React.StrictMode>
        <ToolbarContext>
          <Editor id={millisecondsSinceEpoch.toString()} type={options.editorType} showEquationEditorButton={options.showEquationEditorButton || false} equationEditorContainerElement={options.equationEditorContainerElement} onAutosave={(content) => { options.onAutoSave ? options.onAutoSave(content) : null }} onChange={(content) => { options.onUpdate ? options.onUpdate(content) : null }} initialData={options.initialData} />
        </ToolbarContext>
      </React.StrictMode>,
    );
  }

  destroy() {
    ReactDOM.createRoot(this.options.editorContainerElement).render(
      null
    )
  }
}

export function EssayEditorComponent(options: {id: string} & Omit<Options, "editorContainerElement">) {
  return <ToolbarContext>
    <Editor id={options.id} type={options.editorType} showEquationEditorButton={options.showEquationEditorButton || false} equationEditorContainerElement={options.equationEditorContainerElement} onAutosave={(content) => { options.onAutoSave ? options.onAutoSave(content) : null }} onChange={(content) => { options.onUpdate ? options.onUpdate(content) : null }} initialData={options.initialData} />
  </ToolbarContext>
}